export const pageNames = {
  FEED_CONFIRMATION: 'Feed Confirmation',
  SEND_CODE: 'Send Code',
  VERIFY_CODE: 'Verify Code',
  PODCAST_INFO: 'Podcast Info',
  REVIEW_SUBMIT: 'Review & Submit',
  WELCOME_MESSAGE: 'Welcome Message',
};
